import { instanceOEF, segundaVersaoOEF } from './api'

export const postCodigoResgate = ( codigo ) => {
  const url = `${segundaVersaoOEF}/assinatura-presente/codigo`
  const body = {
    codigo
  }

  return instanceOEF.post( url, body )
}

export const postResgateAssinaturaPresente = ( codigo, idEndereco ) => {
  const url = `${segundaVersaoOEF}/assinatura-presente/presente_resgate_area_associado`

  const body = {
    codigo,
    'entrega': {
      'endereco': {
        'id': idEndereco
      }
    }
  }

  return instanceOEF.post( url, body )
}

